<script setup>
// The whole prompt the assistant receives, as compiled from what is saved: one tab for text, one for voice. Read
// only. Under each, the size (estimated tokens) and the start of its fingerprint, the same one a version keeps.
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from 'dashboard/components-next/polaris/ui/tabs';

const props = defineProps({
  compiled: { type: Object, required: true }, // { text: { prompt, sha, estimated_tokens }, voice: {...} }
});

const { t } = useI18n();
const channel = ref('voice');

const channels = computed(() =>
  ['voice', 'text'].map(id => ({
    id,
    label: t(`POLARIS.ASSISTANTS.VOICE.COMPILED.${id.toUpperCase()}`),
    prompt: props.compiled[id].prompt,
    meta: t('POLARIS.ASSISTANTS.VOICE.COMPILED.META', {
      tokens: props.compiled[id].estimated_tokens,
      sha: props.compiled[id].sha.slice(0, 12),
    }),
  }))
);
</script>

<template>
  <Tabs v-model="channel">
    <TabsList>
      <TabsTrigger v-for="item in channels" :key="item.id" :value="item.id">
        {{ item.label }}
      </TabsTrigger>
    </TabsList>
    <TabsContent
      v-for="item in channels"
      :key="item.id"
      :value="item.id"
      class="grid gap-2"
    >
      <div
        class="max-h-[32rem] overflow-y-auto rounded-polaris-lg border border-solid border-polaris-border bg-polaris-muted p-4"
        tabindex="0"
        role="region"
        :aria-label="item.label"
      >
        <pre
          class="m-0 whitespace-pre-wrap break-words type-polaris-caption text-polaris-foreground"
          :data-compiled-prompt="item.id"
        ><code>{{ item.prompt }}</code></pre>
      </div>
      <p class="type-polaris-caption text-polaris-muted-foreground">
        {{ item.meta }}
      </p>
    </TabsContent>
  </Tabs>
</template>
